import logo from './logo.png';
import missing from './missing.jpg';

export const logoImg = logo;
export const missingImg = missing;
